import { Button } from '../button';
import { ReactNode } from 'react';
import { useGenerateReceiptPdf } from '@/api/generate-receipt-pdf';
import { downloadFile } from '@/util/helpers';

interface DownloadReceiptButtonProps {
  encounterId: number;
  children: ReactNode;
  fileName: string;
  className?: string;
}

export function DownloadReceiptButton({
  encounterId,
  className,
  fileName,
  children,
}: DownloadReceiptButtonProps) {
  const { mutate: generateReceiptPdf, isPending } = useGenerateReceiptPdf();

  const handleDownloadPdf = () => {
    generateReceiptPdf({ encounterId }, { onSuccess: (data) => downloadFile(data, fileName) });
  };

  return (
    <Button
      variant="link"
      leftIcon="description"
      loading={isPending}
      onClick={handleDownloadPdf}
      className={className}
    >
      {children}
    </Button>
  );
}
